import { default as indexipRP5TzoE3Meta } from "/home/runner/work/ags-storefront/ags-storefront/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93BLkYmWgGk5Meta } from "/home/runner/work/ags-storefront/ags-storefront/pages/[...slug].vue?macro=true";
import { default as _91slug_93dSiMqjngP1Meta } from "/home/runner/work/ags-storefront/ags-storefront/pages/account/goldner-club/[slug].vue?macro=true";
import { default as indexhCEY80TPXNMeta } from "/home/runner/work/ags-storefront/ags-storefront/pages/account/goldner-club/index.vue?macro=true";
import { default as indexYWnzsxL1IIMeta } from "/home/runner/work/ags-storefront/ags-storefront/pages/account/index.vue?macro=true";
import { default as _91id_93oKplwyiHg3Meta } from "/home/runner/work/ags-storefront/ags-storefront/pages/account/orders/[id].vue?macro=true";
import { default as ordersIXEYro7NdRMeta } from "/home/runner/work/ags-storefront/ags-storefront/pages/account/orders.vue?macro=true";
import { default as indexwYaQMrfNuCMeta } from "/home/runner/work/ags-storefront/ags-storefront/pages/account/user/index.vue?macro=true";
import { default as basket6owz2ZTMZ1Meta } from "/home/runner/work/ags-storefront/ags-storefront/pages/basket.vue?macro=true";
import { default as _91_46_46_46slug_93AGvlUb4Y7SMeta } from "/home/runner/work/ags-storefront/ags-storefront/pages/c/[...slug].vue?macro=true";
import { default as checkout_external_basketR8vMDucVvCMeta } from "/home/runner/work/ags-storefront/ags-storefront/pages/checkout_external_basket.vue?macro=true";
import { default as checkoutzuMzWskl9vMeta } from "/home/runner/work/ags-storefront/ags-storefront/pages/checkout.vue?macro=true";
import { default as _91slug_934Q3VbJ0lLJMeta } from "/home/runner/work/ags-storefront/ags-storefront/pages/magazine/[slug].vue?macro=true";
import { default as indexqVAVWkwpcjMeta } from "/home/runner/work/ags-storefront/ags-storefront/pages/magazine/index.vue?macro=true";
import { default as index7TGLz43lUJMeta } from "/home/runner/work/ags-storefront/ags-storefront/pages/outfits/[slug]/index.vue?macro=true";
import { default as indexPvXaREteqGMeta } from "/home/runner/work/ags-storefront/ags-storefront/pages/outfits/index.vue?macro=true";
import { default as _91id_93sRuJTR4GiwMeta } from "/home/runner/work/ags-storefront/ags-storefront/pages/p/[slug]/[id].vue?macro=true";
import { default as resetCNgfwe6hmqMeta } from "/home/runner/work/ags-storefront/ags-storefront/pages/password/reset.vue?macro=true";
import { default as search7MxF5j01i9Meta } from "/home/runner/work/ags-storefront/ags-storefront/pages/search.vue?macro=true";
import { default as direct_45order6RYrTu6MTVMeta } from "/home/runner/work/ags-storefront/ags-storefront/pages/service/direct-order.vue?macro=true";
import { default as signinHgTf8UIPerMeta } from "/home/runner/work/ags-storefront/ags-storefront/pages/signin.vue?macro=true";
import { default as successTYZB8XaEPKMeta } from "/home/runner/work/ags-storefront/ags-storefront/pages/success.vue?macro=true";
import { default as wishlistiN5JL02U1XMeta } from "/home/runner/work/ags-storefront/ags-storefront/pages/wishlist.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexipRP5TzoE3Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "slug___at",
    path: "/at/:slug(.*)*",
    meta: _91_46_46_46slug_93BLkYmWgGk5Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___be",
    path: "/be/:slug(.*)*",
    meta: _91_46_46_46slug_93BLkYmWgGk5Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___fr-be",
    path: "/fr-be/:slug(.*)*",
    meta: _91_46_46_46slug_93BLkYmWgGk5Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___ch",
    path: "/ch/:slug(.*)*",
    meta: _91_46_46_46slug_93BLkYmWgGk5Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___fr-ch",
    path: "/fr-ch/:slug(.*)*",
    meta: _91_46_46_46slug_93BLkYmWgGk5Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___de",
    path: "/de/:slug(.*)*",
    meta: _91_46_46_46slug_93BLkYmWgGk5Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___fi",
    path: "/fi/:slug(.*)*",
    meta: _91_46_46_46slug_93BLkYmWgGk5Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    meta: _91_46_46_46slug_93BLkYmWgGk5Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___nl",
    path: "/nl/:slug(.*)*",
    meta: _91_46_46_46slug_93BLkYmWgGk5Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "account-goldner-club-slug___at",
    path: "/at/account/goldner-club/:slug()",
    meta: _91slug_93dSiMqjngP1Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/goldner-club/[slug].vue").then(m => m.default || m)
  },
  {
    name: "account-goldner-club-slug___be",
    path: "/be/account/goldner-club/:slug()",
    meta: _91slug_93dSiMqjngP1Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/goldner-club/[slug].vue").then(m => m.default || m)
  },
  {
    name: "account-goldner-club-slug___fr-be",
    path: "/fr-be/account/goldner-club/:slug()",
    meta: _91slug_93dSiMqjngP1Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/goldner-club/[slug].vue").then(m => m.default || m)
  },
  {
    name: "account-goldner-club-slug___ch",
    path: "/ch/account/goldner-club/:slug()",
    meta: _91slug_93dSiMqjngP1Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/goldner-club/[slug].vue").then(m => m.default || m)
  },
  {
    name: "account-goldner-club-slug___fr-ch",
    path: "/fr-ch/account/goldner-club/:slug()",
    meta: _91slug_93dSiMqjngP1Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/goldner-club/[slug].vue").then(m => m.default || m)
  },
  {
    name: "account-goldner-club-slug___de",
    path: "/de/account/goldner-club/:slug()",
    meta: _91slug_93dSiMqjngP1Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/goldner-club/[slug].vue").then(m => m.default || m)
  },
  {
    name: "account-goldner-club-slug___fi",
    path: "/fi/account/goldner-club/:slug()",
    meta: _91slug_93dSiMqjngP1Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/goldner-club/[slug].vue").then(m => m.default || m)
  },
  {
    name: "account-goldner-club-slug___fr",
    path: "/fr/account/goldner-club/:slug()",
    meta: _91slug_93dSiMqjngP1Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/goldner-club/[slug].vue").then(m => m.default || m)
  },
  {
    name: "account-goldner-club-slug___nl",
    path: "/nl/account/goldner-club/:slug()",
    meta: _91slug_93dSiMqjngP1Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/goldner-club/[slug].vue").then(m => m.default || m)
  },
  {
    name: "account-goldner-club___at",
    path: "/at/account/goldner-club",
    meta: indexhCEY80TPXNMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/goldner-club/index.vue").then(m => m.default || m)
  },
  {
    name: "account-goldner-club___be",
    path: "/be/account/goldner-club",
    meta: indexhCEY80TPXNMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/goldner-club/index.vue").then(m => m.default || m)
  },
  {
    name: "account-goldner-club___fr-be",
    path: "/fr-be/account/goldner-club",
    meta: indexhCEY80TPXNMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/goldner-club/index.vue").then(m => m.default || m)
  },
  {
    name: "account-goldner-club___ch",
    path: "/ch/account/goldner-club",
    meta: indexhCEY80TPXNMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/goldner-club/index.vue").then(m => m.default || m)
  },
  {
    name: "account-goldner-club___fr-ch",
    path: "/fr-ch/account/goldner-club",
    meta: indexhCEY80TPXNMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/goldner-club/index.vue").then(m => m.default || m)
  },
  {
    name: "account-goldner-club___de",
    path: "/de/account/goldner-club",
    meta: indexhCEY80TPXNMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/goldner-club/index.vue").then(m => m.default || m)
  },
  {
    name: "account-goldner-club___fi",
    path: "/fi/account/goldner-club",
    meta: indexhCEY80TPXNMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/goldner-club/index.vue").then(m => m.default || m)
  },
  {
    name: "account-goldner-club___fr",
    path: "/fr/account/goldner-club",
    meta: indexhCEY80TPXNMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/goldner-club/index.vue").then(m => m.default || m)
  },
  {
    name: "account-goldner-club___nl",
    path: "/nl/account/goldner-club",
    meta: indexhCEY80TPXNMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/goldner-club/index.vue").then(m => m.default || m)
  },
  {
    name: "account___at",
    path: "/at/account",
    meta: indexYWnzsxL1IIMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___be",
    path: "/be/account",
    meta: indexYWnzsxL1IIMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___fr-be",
    path: "/fr-be/account",
    meta: indexYWnzsxL1IIMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___ch",
    path: "/ch/account",
    meta: indexYWnzsxL1IIMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___fr-ch",
    path: "/fr-ch/account",
    meta: indexYWnzsxL1IIMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___de",
    path: "/de/account",
    meta: indexYWnzsxL1IIMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___fi",
    path: "/fi/account",
    meta: indexYWnzsxL1IIMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___fr",
    path: "/fr/account",
    meta: indexYWnzsxL1IIMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___nl",
    path: "/nl/account",
    meta: indexYWnzsxL1IIMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account-orders___at",
    path: "/at/account/orders",
    meta: ordersIXEYro7NdRMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/orders.vue").then(m => m.default || m),
    children: [
  {
    name: "account-orders-id___at",
    path: ":id()",
    meta: _91id_93oKplwyiHg3Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/orders/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "account-orders___be",
    path: "/be/account/orders",
    meta: ordersIXEYro7NdRMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/orders.vue").then(m => m.default || m),
    children: [
  {
    name: "account-orders-id___be",
    path: ":id()",
    meta: _91id_93oKplwyiHg3Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/orders/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "account-orders___fr-be",
    path: "/fr-be/account/orders",
    meta: ordersIXEYro7NdRMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/orders.vue").then(m => m.default || m),
    children: [
  {
    name: "account-orders-id___fr-be",
    path: ":id()",
    meta: _91id_93oKplwyiHg3Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/orders/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "account-orders___ch",
    path: "/ch/account/orders",
    meta: ordersIXEYro7NdRMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/orders.vue").then(m => m.default || m),
    children: [
  {
    name: "account-orders-id___ch",
    path: ":id()",
    meta: _91id_93oKplwyiHg3Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/orders/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "account-orders___fr-ch",
    path: "/fr-ch/account/orders",
    meta: ordersIXEYro7NdRMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/orders.vue").then(m => m.default || m),
    children: [
  {
    name: "account-orders-id___fr-ch",
    path: ":id()",
    meta: _91id_93oKplwyiHg3Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/orders/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "account-orders___de",
    path: "/de/account/orders",
    meta: ordersIXEYro7NdRMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/orders.vue").then(m => m.default || m),
    children: [
  {
    name: "account-orders-id___de",
    path: ":id()",
    meta: _91id_93oKplwyiHg3Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/orders/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "account-orders___fi",
    path: "/fi/account/orders",
    meta: ordersIXEYro7NdRMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/orders.vue").then(m => m.default || m),
    children: [
  {
    name: "account-orders-id___fi",
    path: ":id()",
    meta: _91id_93oKplwyiHg3Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/orders/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "account-orders___fr",
    path: "/fr/account/orders",
    meta: ordersIXEYro7NdRMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/orders.vue").then(m => m.default || m),
    children: [
  {
    name: "account-orders-id___fr",
    path: ":id()",
    meta: _91id_93oKplwyiHg3Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/orders/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "account-orders___nl",
    path: "/nl/account/orders",
    meta: ordersIXEYro7NdRMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/orders.vue").then(m => m.default || m),
    children: [
  {
    name: "account-orders-id___nl",
    path: ":id()",
    meta: _91id_93oKplwyiHg3Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/orders/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "account-user___at",
    path: "/at/account/user",
    meta: indexwYaQMrfNuCMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/user/index.vue").then(m => m.default || m)
  },
  {
    name: "account-user___be",
    path: "/be/account/user",
    meta: indexwYaQMrfNuCMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/user/index.vue").then(m => m.default || m)
  },
  {
    name: "account-user___fr-be",
    path: "/fr-be/account/user",
    meta: indexwYaQMrfNuCMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/user/index.vue").then(m => m.default || m)
  },
  {
    name: "account-user___ch",
    path: "/ch/account/user",
    meta: indexwYaQMrfNuCMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/user/index.vue").then(m => m.default || m)
  },
  {
    name: "account-user___fr-ch",
    path: "/fr-ch/account/user",
    meta: indexwYaQMrfNuCMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/user/index.vue").then(m => m.default || m)
  },
  {
    name: "account-user___de",
    path: "/de/account/user",
    meta: indexwYaQMrfNuCMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/user/index.vue").then(m => m.default || m)
  },
  {
    name: "account-user___fi",
    path: "/fi/account/user",
    meta: indexwYaQMrfNuCMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/user/index.vue").then(m => m.default || m)
  },
  {
    name: "account-user___fr",
    path: "/fr/account/user",
    meta: indexwYaQMrfNuCMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/user/index.vue").then(m => m.default || m)
  },
  {
    name: "account-user___nl",
    path: "/nl/account/user",
    meta: indexwYaQMrfNuCMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/account/user/index.vue").then(m => m.default || m)
  },
  {
    name: "basket___at",
    path: "/at/basket",
    meta: basket6owz2ZTMZ1Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/basket.vue").then(m => m.default || m)
  },
  {
    name: "basket___be",
    path: "/be/basket",
    meta: basket6owz2ZTMZ1Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/basket.vue").then(m => m.default || m)
  },
  {
    name: "basket___fr-be",
    path: "/fr-be/basket",
    meta: basket6owz2ZTMZ1Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/basket.vue").then(m => m.default || m)
  },
  {
    name: "basket___ch",
    path: "/ch/basket",
    meta: basket6owz2ZTMZ1Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/basket.vue").then(m => m.default || m)
  },
  {
    name: "basket___fr-ch",
    path: "/fr-ch/basket",
    meta: basket6owz2ZTMZ1Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/basket.vue").then(m => m.default || m)
  },
  {
    name: "basket___de",
    path: "/de/basket",
    meta: basket6owz2ZTMZ1Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/basket.vue").then(m => m.default || m)
  },
  {
    name: "basket___fi",
    path: "/fi/basket",
    meta: basket6owz2ZTMZ1Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/basket.vue").then(m => m.default || m)
  },
  {
    name: "basket___fr",
    path: "/fr/basket",
    meta: basket6owz2ZTMZ1Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/basket.vue").then(m => m.default || m)
  },
  {
    name: "basket___nl",
    path: "/nl/basket",
    meta: basket6owz2ZTMZ1Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/basket.vue").then(m => m.default || m)
  },
  {
    name: "c-slug___at",
    path: "/at/c/:slug(.*)*",
    meta: _91_46_46_46slug_93AGvlUb4Y7SMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "c-slug___be",
    path: "/be/c/:slug(.*)*",
    meta: _91_46_46_46slug_93AGvlUb4Y7SMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "c-slug___fr-be",
    path: "/fr-be/c/:slug(.*)*",
    meta: _91_46_46_46slug_93AGvlUb4Y7SMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "c-slug___ch",
    path: "/ch/c/:slug(.*)*",
    meta: _91_46_46_46slug_93AGvlUb4Y7SMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "c-slug___fr-ch",
    path: "/fr-ch/c/:slug(.*)*",
    meta: _91_46_46_46slug_93AGvlUb4Y7SMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "c-slug___de",
    path: "/de/c/:slug(.*)*",
    meta: _91_46_46_46slug_93AGvlUb4Y7SMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "c-slug___fi",
    path: "/fi/c/:slug(.*)*",
    meta: _91_46_46_46slug_93AGvlUb4Y7SMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "c-slug___fr",
    path: "/fr/c/:slug(.*)*",
    meta: _91_46_46_46slug_93AGvlUb4Y7SMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "c-slug___nl",
    path: "/nl/c/:slug(.*)*",
    meta: _91_46_46_46slug_93AGvlUb4Y7SMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "checkout_external_basket___at",
    path: "/at/checkout_external_basket",
    meta: checkout_external_basketR8vMDucVvCMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/checkout_external_basket.vue").then(m => m.default || m)
  },
  {
    name: "checkout_external_basket___be",
    path: "/be/checkout_external_basket",
    meta: checkout_external_basketR8vMDucVvCMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/checkout_external_basket.vue").then(m => m.default || m)
  },
  {
    name: "checkout_external_basket___fr-be",
    path: "/fr-be/checkout_external_basket",
    meta: checkout_external_basketR8vMDucVvCMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/checkout_external_basket.vue").then(m => m.default || m)
  },
  {
    name: "checkout_external_basket___ch",
    path: "/ch/checkout_external_basket",
    meta: checkout_external_basketR8vMDucVvCMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/checkout_external_basket.vue").then(m => m.default || m)
  },
  {
    name: "checkout_external_basket___fr-ch",
    path: "/fr-ch/checkout_external_basket",
    meta: checkout_external_basketR8vMDucVvCMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/checkout_external_basket.vue").then(m => m.default || m)
  },
  {
    name: "checkout_external_basket___de",
    path: "/de/checkout_external_basket",
    meta: checkout_external_basketR8vMDucVvCMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/checkout_external_basket.vue").then(m => m.default || m)
  },
  {
    name: "checkout_external_basket___fi",
    path: "/fi/checkout_external_basket",
    meta: checkout_external_basketR8vMDucVvCMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/checkout_external_basket.vue").then(m => m.default || m)
  },
  {
    name: "checkout_external_basket___fr",
    path: "/fr/checkout_external_basket",
    meta: checkout_external_basketR8vMDucVvCMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/checkout_external_basket.vue").then(m => m.default || m)
  },
  {
    name: "checkout_external_basket___nl",
    path: "/nl/checkout_external_basket",
    meta: checkout_external_basketR8vMDucVvCMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/checkout_external_basket.vue").then(m => m.default || m)
  },
  {
    name: "checkout___at",
    path: "/at/checkout",
    meta: checkoutzuMzWskl9vMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "checkout___be",
    path: "/be/checkout",
    meta: checkoutzuMzWskl9vMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "checkout___fr-be",
    path: "/fr-be/checkout",
    meta: checkoutzuMzWskl9vMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "checkout___ch",
    path: "/ch/checkout",
    meta: checkoutzuMzWskl9vMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "checkout___fr-ch",
    path: "/fr-ch/checkout",
    meta: checkoutzuMzWskl9vMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "checkout___de",
    path: "/de/checkout",
    meta: checkoutzuMzWskl9vMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "checkout___fi",
    path: "/fi/checkout",
    meta: checkoutzuMzWskl9vMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "checkout___fr",
    path: "/fr/checkout",
    meta: checkoutzuMzWskl9vMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "checkout___nl",
    path: "/nl/checkout",
    meta: checkoutzuMzWskl9vMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "index___at",
    path: "/at",
    meta: indexipRP5TzoE3Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___be",
    path: "/be",
    meta: indexipRP5TzoE3Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___fr-be",
    path: "/fr-be",
    meta: indexipRP5TzoE3Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___ch",
    path: "/ch",
    meta: indexipRP5TzoE3Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___fr-ch",
    path: "/fr-ch",
    meta: indexipRP5TzoE3Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexipRP5TzoE3Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___fi",
    path: "/fi",
    meta: indexipRP5TzoE3Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexipRP5TzoE3Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___nl",
    path: "/nl",
    meta: indexipRP5TzoE3Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "magazine-slug___at",
    path: "/at/magazin/:slug()",
    meta: _91slug_934Q3VbJ0lLJMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/magazine/[slug].vue").then(m => m.default || m)
  },
  {
    name: "magazine-slug___be",
    path: "/be/magazine/:slug()",
    meta: _91slug_934Q3VbJ0lLJMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/magazine/[slug].vue").then(m => m.default || m)
  },
  {
    name: "magazine-slug___fr-be",
    path: "/fr-be/magazine/:slug()",
    meta: _91slug_934Q3VbJ0lLJMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/magazine/[slug].vue").then(m => m.default || m)
  },
  {
    name: "magazine-slug___ch",
    path: "/ch/magazin/:slug()",
    meta: _91slug_934Q3VbJ0lLJMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/magazine/[slug].vue").then(m => m.default || m)
  },
  {
    name: "magazine-slug___fr-ch",
    path: "/fr-ch/magazine/:slug()",
    meta: _91slug_934Q3VbJ0lLJMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/magazine/[slug].vue").then(m => m.default || m)
  },
  {
    name: "magazine-slug___de",
    path: "/de/magazin/:slug()",
    meta: _91slug_934Q3VbJ0lLJMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/magazine/[slug].vue").then(m => m.default || m)
  },
  {
    name: "magazine-slug___fi",
    path: "/fi/magazine/:slug()",
    meta: _91slug_934Q3VbJ0lLJMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/magazine/[slug].vue").then(m => m.default || m)
  },
  {
    name: "magazine-slug___fr",
    path: "/fr/magazine/:slug()",
    meta: _91slug_934Q3VbJ0lLJMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/magazine/[slug].vue").then(m => m.default || m)
  },
  {
    name: "magazine-slug___nl",
    path: "/nl/magazine/:slug()",
    meta: _91slug_934Q3VbJ0lLJMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/magazine/[slug].vue").then(m => m.default || m)
  },
  {
    name: "magazine___at",
    path: "/at/magazin",
    meta: indexqVAVWkwpcjMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/magazine/index.vue").then(m => m.default || m)
  },
  {
    name: "magazine___be",
    path: "/be/magazine",
    meta: indexqVAVWkwpcjMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/magazine/index.vue").then(m => m.default || m)
  },
  {
    name: "magazine___fr-be",
    path: "/fr-be/magazine",
    meta: indexqVAVWkwpcjMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/magazine/index.vue").then(m => m.default || m)
  },
  {
    name: "magazine___ch",
    path: "/ch/magazin",
    meta: indexqVAVWkwpcjMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/magazine/index.vue").then(m => m.default || m)
  },
  {
    name: "magazine___fr-ch",
    path: "/fr-ch/magazine",
    meta: indexqVAVWkwpcjMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/magazine/index.vue").then(m => m.default || m)
  },
  {
    name: "magazine___de",
    path: "/de/magazin",
    meta: indexqVAVWkwpcjMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/magazine/index.vue").then(m => m.default || m)
  },
  {
    name: "magazine___fi",
    path: "/fi/magazine",
    meta: indexqVAVWkwpcjMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/magazine/index.vue").then(m => m.default || m)
  },
  {
    name: "magazine___fr",
    path: "/fr/magazine",
    meta: indexqVAVWkwpcjMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/magazine/index.vue").then(m => m.default || m)
  },
  {
    name: "magazine___nl",
    path: "/nl/magazine",
    meta: indexqVAVWkwpcjMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/magazine/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits-slug___at",
    path: "/at/outfits/:slug()",
    meta: index7TGLz43lUJMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/outfits/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits-slug___be",
    path: "/be/outfits/:slug()",
    meta: index7TGLz43lUJMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/outfits/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits-slug___fr-be",
    path: "/fr-be/ensembles/:slug()",
    meta: index7TGLz43lUJMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/outfits/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits-slug___ch",
    path: "/ch/outfits/:slug()",
    meta: index7TGLz43lUJMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/outfits/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits-slug___fr-ch",
    path: "/fr-ch/ensembles/:slug()",
    meta: index7TGLz43lUJMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/outfits/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits-slug___de",
    path: "/de/outfits/:slug()",
    meta: index7TGLz43lUJMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/outfits/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits-slug___fi",
    path: "/fi/asukokonaisuudet/:slug()",
    meta: index7TGLz43lUJMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/outfits/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits-slug___fr",
    path: "/fr/ensembles/:slug()",
    meta: index7TGLz43lUJMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/outfits/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits-slug___nl",
    path: "/nl/outfits/:slug()",
    meta: index7TGLz43lUJMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/outfits/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits___at",
    path: "/at/outfits",
    meta: indexPvXaREteqGMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/outfits/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits___be",
    path: "/be/outfits",
    meta: indexPvXaREteqGMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/outfits/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits___fr-be",
    path: "/fr-be/ensembles",
    meta: indexPvXaREteqGMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/outfits/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits___ch",
    path: "/ch/outfits",
    meta: indexPvXaREteqGMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/outfits/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits___fr-ch",
    path: "/fr-ch/ensembles",
    meta: indexPvXaREteqGMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/outfits/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits___de",
    path: "/de/outfits",
    meta: indexPvXaREteqGMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/outfits/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits___fi",
    path: "/fi/asukokonaisuudet",
    meta: indexPvXaREteqGMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/outfits/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits___fr",
    path: "/fr/ensembles",
    meta: indexPvXaREteqGMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/outfits/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits___nl",
    path: "/nl/outfits",
    meta: indexPvXaREteqGMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/outfits/index.vue").then(m => m.default || m)
  },
  {
    name: "p-slug-id___at",
    path: "/at/p/:slug()/:id()",
    meta: _91id_93sRuJTR4GiwMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/p/[slug]/[id].vue").then(m => m.default || m)
  },
  {
    name: "p-slug-id___be",
    path: "/be/p/:slug()/:id()",
    meta: _91id_93sRuJTR4GiwMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/p/[slug]/[id].vue").then(m => m.default || m)
  },
  {
    name: "p-slug-id___fr-be",
    path: "/fr-be/p/:slug()/:id()",
    meta: _91id_93sRuJTR4GiwMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/p/[slug]/[id].vue").then(m => m.default || m)
  },
  {
    name: "p-slug-id___ch",
    path: "/ch/p/:slug()/:id()",
    meta: _91id_93sRuJTR4GiwMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/p/[slug]/[id].vue").then(m => m.default || m)
  },
  {
    name: "p-slug-id___fr-ch",
    path: "/fr-ch/p/:slug()/:id()",
    meta: _91id_93sRuJTR4GiwMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/p/[slug]/[id].vue").then(m => m.default || m)
  },
  {
    name: "p-slug-id___de",
    path: "/de/p/:slug()/:id()",
    meta: _91id_93sRuJTR4GiwMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/p/[slug]/[id].vue").then(m => m.default || m)
  },
  {
    name: "p-slug-id___fi",
    path: "/fi/p/:slug()/:id()",
    meta: _91id_93sRuJTR4GiwMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/p/[slug]/[id].vue").then(m => m.default || m)
  },
  {
    name: "p-slug-id___fr",
    path: "/fr/p/:slug()/:id()",
    meta: _91id_93sRuJTR4GiwMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/p/[slug]/[id].vue").then(m => m.default || m)
  },
  {
    name: "p-slug-id___nl",
    path: "/nl/p/:slug()/:id()",
    meta: _91id_93sRuJTR4GiwMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/p/[slug]/[id].vue").then(m => m.default || m)
  },
  {
    name: "password-reset___at",
    path: "/at/password/reset",
    meta: resetCNgfwe6hmqMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/password/reset.vue").then(m => m.default || m)
  },
  {
    name: "password-reset___be",
    path: "/be/password/reset",
    meta: resetCNgfwe6hmqMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/password/reset.vue").then(m => m.default || m)
  },
  {
    name: "password-reset___fr-be",
    path: "/fr-be/password/reset",
    meta: resetCNgfwe6hmqMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/password/reset.vue").then(m => m.default || m)
  },
  {
    name: "password-reset___ch",
    path: "/ch/password/reset",
    meta: resetCNgfwe6hmqMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/password/reset.vue").then(m => m.default || m)
  },
  {
    name: "password-reset___fr-ch",
    path: "/fr-ch/password/reset",
    meta: resetCNgfwe6hmqMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/password/reset.vue").then(m => m.default || m)
  },
  {
    name: "password-reset___de",
    path: "/de/password/reset",
    meta: resetCNgfwe6hmqMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/password/reset.vue").then(m => m.default || m)
  },
  {
    name: "password-reset___fi",
    path: "/fi/password/reset",
    meta: resetCNgfwe6hmqMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/password/reset.vue").then(m => m.default || m)
  },
  {
    name: "password-reset___fr",
    path: "/fr/password/reset",
    meta: resetCNgfwe6hmqMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/password/reset.vue").then(m => m.default || m)
  },
  {
    name: "password-reset___nl",
    path: "/nl/password/reset",
    meta: resetCNgfwe6hmqMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/password/reset.vue").then(m => m.default || m)
  },
  {
    name: "search___at",
    path: "/at/search",
    meta: search7MxF5j01i9Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "search___be",
    path: "/be/search",
    meta: search7MxF5j01i9Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "search___fr-be",
    path: "/fr-be/search",
    meta: search7MxF5j01i9Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "search___ch",
    path: "/ch/search",
    meta: search7MxF5j01i9Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "search___fr-ch",
    path: "/fr-ch/search",
    meta: search7MxF5j01i9Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "search___de",
    path: "/de/search",
    meta: search7MxF5j01i9Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "search___fi",
    path: "/fi/search",
    meta: search7MxF5j01i9Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "search___fr",
    path: "/fr/search",
    meta: search7MxF5j01i9Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "search___nl",
    path: "/nl/search",
    meta: search7MxF5j01i9Meta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "service-direct-order___at",
    path: "/at/service/direct-order",
    meta: direct_45order6RYrTu6MTVMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/service/direct-order.vue").then(m => m.default || m)
  },
  {
    name: "service-direct-order___be",
    path: "/be/service/direct-order",
    meta: direct_45order6RYrTu6MTVMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/service/direct-order.vue").then(m => m.default || m)
  },
  {
    name: "service-direct-order___fr-be",
    path: "/fr-be/service/direct-order",
    meta: direct_45order6RYrTu6MTVMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/service/direct-order.vue").then(m => m.default || m)
  },
  {
    name: "service-direct-order___ch",
    path: "/ch/service/direct-order",
    meta: direct_45order6RYrTu6MTVMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/service/direct-order.vue").then(m => m.default || m)
  },
  {
    name: "service-direct-order___fr-ch",
    path: "/fr-ch/service/direct-order",
    meta: direct_45order6RYrTu6MTVMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/service/direct-order.vue").then(m => m.default || m)
  },
  {
    name: "service-direct-order___de",
    path: "/de/service/direct-order",
    meta: direct_45order6RYrTu6MTVMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/service/direct-order.vue").then(m => m.default || m)
  },
  {
    name: "service-direct-order___fi",
    path: "/fi/service/direct-order",
    meta: direct_45order6RYrTu6MTVMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/service/direct-order.vue").then(m => m.default || m)
  },
  {
    name: "service-direct-order___fr",
    path: "/fr/service/direct-order",
    meta: direct_45order6RYrTu6MTVMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/service/direct-order.vue").then(m => m.default || m)
  },
  {
    name: "service-direct-order___nl",
    path: "/nl/service/direct-order",
    meta: direct_45order6RYrTu6MTVMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/service/direct-order.vue").then(m => m.default || m)
  },
  {
    name: "signin___at",
    path: "/at/signin",
    meta: signinHgTf8UIPerMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/signin.vue").then(m => m.default || m)
  },
  {
    name: "signin___be",
    path: "/be/signin",
    meta: signinHgTf8UIPerMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/signin.vue").then(m => m.default || m)
  },
  {
    name: "signin___fr-be",
    path: "/fr-be/signin",
    meta: signinHgTf8UIPerMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/signin.vue").then(m => m.default || m)
  },
  {
    name: "signin___ch",
    path: "/ch/signin",
    meta: signinHgTf8UIPerMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/signin.vue").then(m => m.default || m)
  },
  {
    name: "signin___fr-ch",
    path: "/fr-ch/signin",
    meta: signinHgTf8UIPerMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/signin.vue").then(m => m.default || m)
  },
  {
    name: "signin___de",
    path: "/de/signin",
    meta: signinHgTf8UIPerMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/signin.vue").then(m => m.default || m)
  },
  {
    name: "signin___fi",
    path: "/fi/signin",
    meta: signinHgTf8UIPerMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/signin.vue").then(m => m.default || m)
  },
  {
    name: "signin___fr",
    path: "/fr/signin",
    meta: signinHgTf8UIPerMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/signin.vue").then(m => m.default || m)
  },
  {
    name: "signin___nl",
    path: "/nl/signin",
    meta: signinHgTf8UIPerMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/signin.vue").then(m => m.default || m)
  },
  {
    name: "success___at",
    path: "/at/success",
    meta: successTYZB8XaEPKMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/success.vue").then(m => m.default || m)
  },
  {
    name: "success___be",
    path: "/be/success",
    meta: successTYZB8XaEPKMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/success.vue").then(m => m.default || m)
  },
  {
    name: "success___fr-be",
    path: "/fr-be/success",
    meta: successTYZB8XaEPKMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/success.vue").then(m => m.default || m)
  },
  {
    name: "success___ch",
    path: "/ch/success",
    meta: successTYZB8XaEPKMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/success.vue").then(m => m.default || m)
  },
  {
    name: "success___fr-ch",
    path: "/fr-ch/success",
    meta: successTYZB8XaEPKMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/success.vue").then(m => m.default || m)
  },
  {
    name: "success___de",
    path: "/de/success",
    meta: successTYZB8XaEPKMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/success.vue").then(m => m.default || m)
  },
  {
    name: "success___fi",
    path: "/fi/success",
    meta: successTYZB8XaEPKMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/success.vue").then(m => m.default || m)
  },
  {
    name: "success___fr",
    path: "/fr/success",
    meta: successTYZB8XaEPKMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/success.vue").then(m => m.default || m)
  },
  {
    name: "success___nl",
    path: "/nl/success",
    meta: successTYZB8XaEPKMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/success.vue").then(m => m.default || m)
  },
  {
    name: "wishlist___at",
    path: "/at/wishlist",
    meta: wishlistiN5JL02U1XMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/wishlist.vue").then(m => m.default || m)
  },
  {
    name: "wishlist___be",
    path: "/be/wishlist",
    meta: wishlistiN5JL02U1XMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/wishlist.vue").then(m => m.default || m)
  },
  {
    name: "wishlist___fr-be",
    path: "/fr-be/wishlist",
    meta: wishlistiN5JL02U1XMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/wishlist.vue").then(m => m.default || m)
  },
  {
    name: "wishlist___ch",
    path: "/ch/wishlist",
    meta: wishlistiN5JL02U1XMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/wishlist.vue").then(m => m.default || m)
  },
  {
    name: "wishlist___fr-ch",
    path: "/fr-ch/wishlist",
    meta: wishlistiN5JL02U1XMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/wishlist.vue").then(m => m.default || m)
  },
  {
    name: "wishlist___de",
    path: "/de/wishlist",
    meta: wishlistiN5JL02U1XMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/wishlist.vue").then(m => m.default || m)
  },
  {
    name: "wishlist___fi",
    path: "/fi/wishlist",
    meta: wishlistiN5JL02U1XMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/wishlist.vue").then(m => m.default || m)
  },
  {
    name: "wishlist___fr",
    path: "/fr/wishlist",
    meta: wishlistiN5JL02U1XMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/wishlist.vue").then(m => m.default || m)
  },
  {
    name: "wishlist___nl",
    path: "/nl/wishlist",
    meta: wishlistiN5JL02U1XMeta || {},
    component: () => import("/home/runner/work/ags-storefront/ags-storefront/pages/wishlist.vue").then(m => m.default || m)
  }
]